export default __webpack_public_path__ + "static/bonsai-tree-wax-3bdc28f5e6f213f6079a73d0e6a53ba0.png";